import { getThemeState } from '../redux/theme/selectors';
import { useSelector } from 'react-redux';

export function useTheme() {
    const theme = useSelector(getThemeState);
    return theme;
}
